export default __webpack_public_path__ + "static/map-eab7b3f9a8a4d2a5a55732c79ae7c680.jpg";